export class AccordionController {
  constructor() {
    let accordionItem = document.querySelector('.js-accordion');
    if (accordionItem) {
      this.initAccordion();
    }
  }

  initAccordion() {
    const accordionItemSelector = '.js-accordion';
    const accordionItems = document.querySelectorAll(accordionItemSelector);
    const visibleClass = 'visible';
    accordionItems.forEach(function (accordionItem) {
      const accordionButton2 = accordionItem.querySelector('.js-accordionButton');
      if (accordionButton2 instanceof HTMLElement) {
        accordionButton2.addEventListener('click', function () {
          // Remove all visible classes and add the visible class to the current selected
          const currentAccordionItem = accordionItem;
          // Check if the clicked accordion item is closed
          if (!currentAccordionItem.classList.contains(visibleClass)) {
            const accordionParent = currentAccordionItem?.parentElement?.parentElement;
            const accordionWrappers = accordionParent?.childNodes;
            // Close other accordion items of the current accordion
            accordionWrappers?.forEach(function (accordionWrapper) {
              if (accordionWrapper instanceof HTMLElement && accordionWrapper.classList.contains('frame--type-ausproject_accordion')) {
                const openedAccordionItem = accordionWrapper.querySelector(accordionItemSelector + '.' + visibleClass);
                if (openedAccordionItem && openedAccordionItem.id !== currentAccordionItem.id) {
                  openedAccordionItem.classList.remove(visibleClass);
                }
              }
            });
            // Open clicked accordion item
            currentAccordionItem.classList.add(visibleClass);
          } else {
            // Close clicked accordion item
            currentAccordionItem.classList.remove(visibleClass);
          }
        });
      }
    });
  }
}
